module.exports = __webpack_public_path__ + "media/clock-alarm-8761.28ab7cb6.mp3";